import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const Weeklydrivehome = ({token}) => {

    const navigate = useNavigate();
         const handleNavigate = () => {
       const path = token ? `/driver-form?allow=${token}` : '/driver-form';
       navigate(path);
     };
  return (
<div
  className="mt-10 bg-white shadow-lg rounded p-4 px-6 border-[1.5px] border-gray-100
  flex flex-col justify-between
  "
>
  {/* Title */}
  <div className="text-[13px] font-semibold text-left">
    WEEKLY DRIVER LOG & SAFETY
  </div>

  {/* Bottom buttons */}
  <div className="flex justify-center mt-6 gap-2">
    <button
      onClick={handleNavigate}
      className="bg-black text-xs text-white px-3 py-2 flex-1 rounded flex items-center justify-center gap-1 transition hover:bg-gray-900"
    >
      <FiFileText className="text-sm" />
      Fill out Form
    </button>
    <button
      onClick={() => navigate(`/merge-dashboard?type=weekly`)}
      className="bg-[#1E4976] text-xs text-white px-1 py-2 flex-1 rounded flex items-center justify-center gap-1 transition hover:bg-[#163a5e]"
    >
      Reports
    </button>
  </div>
</div>

  );
};

export default Weeklydrivehome;


